module.exports = __webpack_public_path__ + "img/detencionExcesiva.3d2c3b5c.svg";